import { render, staticRenderFns } from "./GameTabTemplate.vue?vue&type=template&id=a3c107ca&scoped=true&"
import script from "./GameTabTemplate.vue?vue&type=script&lang=js&"
export * from "./GameTabTemplate.vue?vue&type=script&lang=js&"
import style0 from "./GameTabTemplate.vue?vue&type=style&index=0&id=a3c107ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c107ca",
  null
  
)

export default component.exports